import { isObjectRecord } from "../../typeGuards/isObjectRecord";
import { ArsTableRowHeader } from "../interface";

/**
 * Type guard for ArsTableRowHeader.
 *
 * @param obj - The object to check.
 * @param isT - A type guard function for the generic type T.
 * @returns True if the object is an ArsTableRowHeader, false otherwise.
 */
export const isArsTableRowHeader = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T = (value: unknown): value is T => typeof value === "string",
): obj is ArsTableRowHeader<T> => {
  if (!isObjectRecord(obj)) return false;
  if (!Array.isArray(obj.heights) || obj.heights.some((h: unknown) => typeof h !== "number"))
    return false;
  if (!isT(obj.label)) return false;
  if (typeof obj.width !== "number") return false;
  return true;
};
